let sections;
let links;

const scrollspy = () => {
	const pageYPosition = document.documentElement.scrollTop || document.body.scrollTop;

	sections.forEach((section) => {
		const sectionYPosition = section.offsetTop;
		const sectionendYPosition = section.offsetTop + section.offsetHeight;

		if (pageYPosition > sectionYPosition - 64 && pageYPosition < sectionendYPosition - 64) {
			$('.header').addClass('header__black');
		}

		if (pageYPosition < sectionYPosition - 64 || pageYPosition > sectionendYPosition - 64) {
			$('.header').removeClass('header__black');
		}
	});
};

const init = () => {
	links = document.querySelectorAll('.js-menu-link');
	sections = document.querySelectorAll('.black-section');
	window.addEventListener('scroll', scrollspy);
	window.addEventListener('load', scrollspy);
	window.addEventListener('resize', scrollspy);
	scrollspy();
};

const destroy = () => {
	window.removeEventListener('scroll', scrollspy);
	window.removeEventListener('load', scrollspy);
	window.removeEventListener('resize', scrollspy);
	if (sections) {
		sections = null;
	}

	if (links) {
		links = null;
	}
};

export default {
	init,
	destroy,
};

